import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import './map-component-style.css';

// Fix for the default marker icon
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

  function RecenterMap({ userCurrentLoc }) {
    const map = useMap();
  
    useEffect(() => {
      if (userCurrentLoc ) {
        map.setView(userCurrentLoc, 15); 
      }
    }, [userCurrentLoc, map ]);
  
    return null; 
  }
function MapToPutMarker2({ initialLocation, zoom, userCurrentLoc,setUserCurrentLoc }) {
  const [position, setPosition] = useState([initialLocation[0], initialLocation[1]]);

  useEffect(() => {
    localStorage.setItem('selectedUserPosition', JSON.stringify(position));
  }, [position]);

console.log(position,"position 12345");
console.log(userCurrentLoc,"position 12345555555555555555555555");


  function LocationMarker() {
    const map = useMapEvents({
      click(e) {
        const newPos = [e.latlng.lat, e.latlng.lng];
        console.log(newPos,"newPos");
        
        setPosition(newPos);
        setUserCurrentLoc(newPos)
        localStorage.setItem('selectedUserPosition', JSON.stringify(newPos));
        localStorage.setItem('userLocationInProfile', JSON.stringify(newPos));
        map.flyTo(newPos, map.getZoom());
        console.log(JSON.stringify(newPos),"JSON.stringify(newPos)");
        
      }
    });

    useEffect(() => {
      if (userCurrentLoc) {
        setPosition(userCurrentLoc);
        // setUserCurrentLoc(userCurrentLoc)
        map.setView(userCurrentLoc, 15); // Zoom to user's current location when it is set
      }
    }, [userCurrentLoc, map]);

    return <Marker position={position} />;
  }

  return (
    <MapContainer className='custom-styles-index-map' center={position} zoom={zoom} scrollWheelZoom={false}>
      <TileLayer
        attribution='&copy; <a href="https://stadiamaps.com/" target="_blank">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>'
        url="https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png"
      />

      {/* Add the recenter component to zoom to the user's location */}
      {userCurrentLoc && <RecenterMap userCurrentLoc={userCurrentLoc} />} 
      
      <LocationMarker />
    </MapContainer>
  );
}

export default MapToPutMarker2;